module.exports = __webpack_public_path__ + "img/itx-file-type-audio.ae0da6ae.svg";